import {JsonPipe, NgIf} from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-preview-media',
  standalone: true,
  imports: [
    NgIf,
    TranslateModule,
    JsonPipe
  ],
  templateUrl: './preview-media.component.html',
})
export class PreviewMediaComponent {
  @Input() selectedMedia: any;
  @Input() photoPreview = false;
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() download = new EventEmitter<boolean>();
}
